// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UStW","col":"styles_col__3WooX"};